import OnboardingAdminOneDashboardPanel from "dashboard/AdminOnePanels/Onboarding/app";
import ContactBirthdaysPanel from "dashboard/ContactBirthdays/app";
import CheatingReprimands from "dashboard/AdminOnePanels/CheatingReprimands/app";
import PaymentMethodProblems from "dashboard/AdminOnePanels/ClientPaymentMethodProblems/app";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import StripePaymentIntentList from "dashboard/AdminOnePanels/StripePaymentIntent/app";
import { isPanelVisible } from "utilities/panelUtils";
import HealthPanel from "./AdminOnePanels/Health/App";
import UsefulLinksPanel from "./AdminOnePanels/UsefulLinks/App";
import { useLoaderData } from "react-router";
import GrowthChurnPanel from "./AdminOnePanels/GrowthChurn/App";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import SubscriptionsPanel from "./AdminOnePanels/Subscriptions/App";

const AdminOneDashboard = () => {
  const viewModel = useLoaderData<server.viewmodel.DashboardAdminOneFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn
      gap="bigger"
    >
      <SectionPanel.Section>
        <OnboardingAdminOneDashboardPanel />
        <CheatingReprimands />
        <GrowthChurnPanel />
        <SubscriptionsPanel />
      </SectionPanel.Section>
    </TwoColumnLayout.LeftColumn>

    <TwoColumnLayout.RightColumn
      gap="bigger">

      {isPanelVisible(viewModel.healthPanelConfig) &&
        <HealthPanel config={viewModel.healthPanelConfig} />}

      {isPanelVisible(viewModel.usefulLinksPanelConfig) &&
        <UsefulLinksPanel config={viewModel.usefulLinksPanelConfig} />}

      <PaymentMethodProblems />

      <StripePaymentIntentList />

      {isPanelVisible(viewModel.contactBirthdayPanelConfig) &&
        <ContactBirthdaysPanel config={viewModel.contactBirthdayPanelConfig} />}
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
};

export default AdminOneDashboard;